<template>
  <div>
    <div class="common-title" id="OFFICIAL-RELEASE">
      <smcaiot-tab
        v-model="val"
        :tabs="newsTabs"
        @handleTabClick="handleTabClick"
      ></smcaiot-tab>
    </div>
    <div>
      <div class="cards">
        <div v-for="(item, index) of news" :key="index" class="card">
          <div class="img">
            <img :src="item.src" />
          </div>
          <div class="text">
            <div class="title" @click="openInfo(item.infoId, item.infoType)">
              {{ item.title }}
            </div>
            <div class="sub">{{ item.introduction }}</div>
          </div>
          <div class="date">{{ item.dateTime }}</div>
        </div>
        <div class="page">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pagination.pageNum"
            :page-size="pagination.pageSize"
            :page-sizes="pagination.sizes"
            :layout="pagination.layout"
            :total="pagination.total"
            :pager-count="pagination.pageCount"
            hide-on-single-page
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import smcaiotTab from "../components/tab.vue";
import axios from "axios";
import { originUrl } from "@/utils";
import { mapMutations } from "vuex";
import { formatDate } from "@/utils";
export default {
  name: "release",
  components: {
    smcaiotTab
  },
  data() {
    return {
      newsTabs: [
        { text: "媒体报道", infoType: "02" },
        { text: "官方发布", infoType: "01" }
      ],
      val: "02",
      jsonData: [],
      tableData: [],
      news: [],
      pagination: {
        pageNum: 1,
        pageSize: 3,
        pageSizes: [3, 6, 9],
        pageCount: 11,
        total: 0,
        layout: "prev, pager, next"
      }
    };
  },
  computed: {
    swipers() {
      const { news } = this;
      const result = [];
      let now = [];
      news.forEach((item, i) => {
        if (i % 3 === 0) {
          now = [item];
          result.push(now);
        } else {
          now.push(item);
        }
      });
      return result;
    }
  },
  created() {
    console.log();
    axios
      .get(`/fs-sm/push/info.json`)
      .then(response => {
        if (response.status == 200) {
          let data = response.data;
          this.jsonData = data;
          this.handleTabClick(this.newsTabs[0]);
        }
      })
      .catch(error => {
        console.log(error);
      });
  },
  methods: {
    ...mapMutations(["setJsonData"]),
    handleTabClick(tab) {
      this.val = tab.infoType;
      this.tableData = this.jsonData.filter(
        item => item.infoType == tab.infoType
      );
      this.tableData.forEach(item => {
        item.src = `${originUrl}${item.coverPath.slice(1)}`;
        item.dateTime = formatDate(item.crtTime, "yyyy-MM-dd");
      });
      console.log(this.tableData);
      let { pageNum, pageSize, total } = this.pagination;
      this.pagination.total = this.tableData.length;
      this.pagination.pageNum = 1;
      this.news = this.tableData.slice(0, pageSize);
    },
    openInfo(id, type) {
      this.$router.push({
        path: "/news-info",
        query: { newsId: id, type }
      });
    },
    handleSizeChange(val) {
      console.log(`每页${val}条`);
    },
    handleCurrentChange(val) {
      let { pageNum, pageSize } = this.pagination;
      this.news = this.tableData.slice(
        (pageNum - 1) * pageSize,
        pageNum * pageSize
      );
    }
  }
};
</script>
<style lang="less" scoped>
.content {
  padding-bottom: 6.4rem;
}
.cards {
  width: 66.8rem;
  margin: 0 auto;
}
.card {
  position: relative;
  display: flex;
  padding: 1.46rem 1.63rem 1.54rem;
  border-bottom: 1px solid #e1e1e1;
  &:last-child {
    border-bottom: none;
  }
}
.img {
  width: 22rem;
  height: 10.7rem;
  margin-right: 2.15rem;
  > img {
    width: 100%;
    height: 100%;
  }
}
.text {
  width: 28.15rem;
  margin-right: 14.5rem;
}
.title {
  display: block;
  font-size: 1.2rem;
  font-weight: bold;
  color: rgba(42, 46, 46, 1);
  line-height: 1.3;
  letter-spacing: 2px;
  margin-bottom: 1.5rem;
  &:hover {
    color: #2f61ae;
    cursor: pointer;
  }
}
.sub {
  font-size: 0.9rem;
  color: rgba(95, 100, 100, 1);
  line-height: 1.2;
  letter-spacing: 1px;
}
.date {
  position: absolute;
  top: 1.46rem;
  right: 3rem;
  font-size: 0.9rem;
  font-weight: bold;
  color: #999999;
  line-height: 1.3;
  letter-spacing: 2px;
  white-space: nowrap;
}
.page {
  margin: 3.55rem 0 6rem;
  & /deep/.el-pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.8rem;
    button {
      height: inherit !important;
      line-height: inherit !important;
      display: inline-block;
      padding: 0.5rem !important;
      margin: 0 0.3rem;
      border: 1px solid #e6e6e6;
      i {
        width: 0.88rem;
        height: 0.53rem;

        background-repeat: no-repeat;
        background-size: 100% 100%;
        &::before {
          content: "";
        }
      }
      &.btn-prev {
        i {
          background-image: url("~@/assets/images/newsCenter/btn_next.png");
          transform: rotate(180deg);
        }
        &:disabled i {
          background-image: url("~@/assets/images/newsCenter/btn_prev.png");
          transform: rotate(0deg);
        }
      }
      &.btn-next {
        i {
          background-image: url("~@/assets/images/newsCenter/btn_next.png");
        }
        &:disabled i {
          background-image: url("~@/assets/images/newsCenter/btn_prev.png");
          transform: rotate(180deg);
        }
      }
    }
    .el-pager {
      li {
        margin: 0 0.3rem;
        padding: 0.5rem;
        color: #333333;
        height: auto !important;
        line-height: 1;
        border: 1px solid #e6e6e6;
        &.active {
          color: #ffffff;
          background-color: #2f61ae;
        }
      }
    }
  }
}
</style>
